import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const LanguageInfo = styled.div<React.CSSProperties>`
  font-family: ${Fonts['regular']};
  font-size: ${30 * Screen.widthRatio}px;
  color: ${Colors['light']};
  left: ${1410 * Screen.widthRatio}px;
  line-height: ${43 * Screen.widthRatio}px;
  position: absolute;
  width: ${910 * Screen.widthRatio}px;
  top: ${392 * Screen.widthRatio}px;
`;

export default LanguageInfo;
